import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { IonContent, IonPage, useIonToast } from "@ionic/react";
import { addOutline } from "ionicons/icons";

import {
  FechaDeGrupo,
  HistorialTrabajoProps,
  RegistroHistórico,
} from "src/utils/interfaces";
import {
  compararHistorialFecha,
  conseguirFechasDeGrupos,
} from "src/utils/fechas";
import {
  getMainScroll,
  getQueryParam,
  setMainScroll,
  setQueryParam,
} from "src/utils/domAndURLs";
import { filtrosActivosATexto } from "src/utils/especificos";

import historialAPI from "src/services/historial";

import Historial from "src/components/Historial/Historial";
import Header from "src/components/Header";
import FAB from "src/components/FloatingActionButton";

const HistorialDeTrabajo: React.FC<HistorialTrabajoProps> = (
  props: HistorialTrabajoProps
) => {
  const [registros, setRegistros] = useState<RegistroHistórico[]>([]);
  const [fechasDeGrupos, setFechasDeGrupos] = useState<FechaDeGrupo[]>([]);
  const [present] = useIonToast();

  const previousHeight = parseInt(getQueryParam("previousHeight") ?? "0");

  useEffect(() => {
    solicitarRegistros();

    return () => {};
  }, [props.filtros]);

  useEffect(() => {
    if (previousHeight) setMainScroll(previousHeight);
  }, [registros]);

  const solicitarRegistros = () => {
    historialAPI.registrosDelHistorial(props.filtros).then(
      (nuevos) => {
        if (nuevos.length > 0) {
          const registrosActualizados = nuevos as RegistroHistórico[];

          registrosActualizados.sort(compararHistorialFecha).reverse();
          const grupos = conseguirFechasDeGrupos(registrosActualizados);

          setFechasDeGrupos(grupos);
          setRegistros(registrosActualizados);
        } else {
          setFechasDeGrupos([]);
          setRegistros([]);

          present({
            message: "No se encontraron marcaciones.",
            duration: 5000,
          });
        }
      },
      (error) => {
        present({
          message: error.response ? error.response.data.Error : error,
          duration: 5000,
        });
      }
    );
  };

  const agregarReclamo = () => {
    const alturaActual = getMainScroll() ?? 0;
    const newURL = setQueryParam("previousHeight", alturaActual);
    const urlSinHost = `${newURL.pathname}${newURL.search}`;
    props.history.push(urlSinHost);

    const linkReclamo = `/reclamos/procesar?pageFrom=${props.location.pathname}`;
    props.history.push(linkReclamo);
  };

  const irAFiltros = () => {
    const alturaActual = getMainScroll() ?? 0;
    const newURL = setQueryParam("previousHeight", alturaActual);
    const urlSinHost = `${newURL.pathname}${newURL.search}`;
    props.history.push(urlSinHost);

    props.history.push("/historial-de-trabajo/filtros");
  };

  const filtrosActivos = props.filtros
    ? filtrosActivosATexto(props.filtros)
    : "";

  const botonFiltrar = {
    src: "assets/icon/filter.svg",
    action: irAFiltros,
  };

  return (
    <IonPage>
      <Header titulo="Historial de Trabajo" botonesDerecha={[botonFiltrar]} />

      <IonContent id="historial-de-trabajo">
        <div className="container">
          <div className="active-filtros">
            <p className="m-0 py-1">{filtrosActivos}</p>
          </div>

          <Historial
            registros={registros}
            fechasDeGrupos={fechasDeGrupos}
            cargo={props.cargo}
          />
        </div>

        <FAB icon={addOutline} handleClick={agregarReclamo} />
      </IonContent>
    </IonPage>
  );
};

export default withRouter(HistorialDeTrabajo);
